import Axios from "axios";
import {
  AddMainCategoryRequest,
  AddSubCategoryRequest,
  GetCategoriesByMainCategoryIdRequest,
  GetCategoriesByMainCategoryIdResponse,
  GetMainCategoriesRequest,
  GetMainCategoriesResponse,
  GetMainCategoryByIdResponse,
  GetSubCategoryByIdResponse,
  MainCategoryByIdRequest,
} from "../models/productCategory.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, CategoryBaseURL } from "../config/config";

export const GetMainCategories = async (
  data: GetMainCategoriesRequest
): Promise<ApiResultModel<GetMainCategoriesResponse[]>> => {
  return await Axios.post<ApiResultModel<GetMainCategoriesResponse[]>>(
    ApiBaseUrl + CategoryBaseURL + "/GetMainCategories",
    data
  ).then((result) => {
    return result.data;
  });
};

export const AddMainCategory = (
  data: AddMainCategoryRequest
): Promise<boolean> => {
  const formData = new FormData();
  formData.append("Title", data.title);
  formData.append("EnglishTitle", data.englishTitle);
  formData.append("Logo", data.logo?.fileData!);
  formData.append("SortIndex", data.sortIndex.toString());
  formData.append("HexCode", data.hexCode);
  formData.append("IsActive", data.isActive.toString());

  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + CategoryBaseURL + "/AddMainCategory",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};
export const UpdateMainCategory = (
  data: AddMainCategoryRequest
): Promise<boolean> => {
  const formData = new FormData();
  formData.append("Title", data.title);
  formData.append("EnglishTitle", data.englishTitle);
  if (data.logo?.fileData) {
    formData.append("Logo", data.logo.fileData);
  } else {
    formData.append("Logo", new Blob(), "");
  }
  formData.append("SortIndex", data.sortIndex.toString());
  formData.append("HexCode", data.hexCode);
  formData.append("IsActive", data.isActive.toString());

  return Axios.put<ApiResultModel<boolean>>(
    ApiBaseUrl + CategoryBaseURL + "/UpdateMainCategory/" + data.id,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};

export const GetMainCategoryById = (
  data: MainCategoryByIdRequest
): Promise<ApiResultModel<GetMainCategoryByIdResponse>> => {
  return Axios.get<ApiResultModel<GetMainCategoryByIdResponse>>(
    ApiBaseUrl + CategoryBaseURL + "/GetMainCategoryById/" + data.id
  ).then((result) => {
    return result.data;
  });
};
export const DeleteMainCategory = async (
  data: MainCategoryByIdRequest
): Promise<ApiResultModel<boolean>> => {
  return await Axios.delete<ApiResultModel<boolean>>(
    ApiBaseUrl + CategoryBaseURL + "/DeleteMainCategory/" + data.id
  ).then((result) => {
    return result.data;
  });
};

export const GetCategoriesByMainCategoryId = (
  data: GetCategoriesByMainCategoryIdRequest
): Promise<ApiResultModel<GetCategoriesByMainCategoryIdResponse>> => {
  return Axios.get<ApiResultModel<GetCategoriesByMainCategoryIdResponse>>(
    ApiBaseUrl +
      CategoryBaseURL +
      "/GetCategoriesByMainCategoryId/" +
      data.mainCategoryId
  ).then((result) => {
    return result.data;
  });
};

export const AddSubCategory = (
  data: AddSubCategoryRequest
): Promise<boolean> => {
  const formData = new FormData();
  formData.append("MainCategoryId", data.mainCategoryId.toString());
  formData.append("Title", data.title);
  formData.append("EnglishTitle", data.englishTitle);
  formData.append("Logo", data.logo?.fileData!);
  formData.append("SortIndex", data.sortIndex.toString());
  formData.append("HexCode", data.hexCode);
  formData.append("IsActive", data.isActive.toString());

  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + CategoryBaseURL + "/AddSubCategory",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};
export const UpdateSubCategory = (
  data: AddMainCategoryRequest
): Promise<boolean> => {
  const formData = new FormData();
  formData.append("Title", data.title);
  formData.append("EnglishTitle", data.englishTitle);
  if (data.logo?.fileData) {
    formData.append("Logo", data.logo.fileData);
  } else {
    formData.append("Logo", new Blob(), "");
  }
  formData.append("SortIndex", data.sortIndex.toString());
  formData.append("HexCode", data.hexCode);
  formData.append("IsActive", data.isActive.toString());

  return Axios.put<ApiResultModel<boolean>>(
    ApiBaseUrl + CategoryBaseURL + "/UpdateSubCategory/" + data.id,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSubCategoryById = (
  data: MainCategoryByIdRequest
): Promise<ApiResultModel<GetSubCategoryByIdResponse>> => {
  return Axios.get<ApiResultModel<GetSubCategoryByIdResponse>>(
    ApiBaseUrl + CategoryBaseURL + "/GetSubCategoryById/" + data.id
  ).then((result) => {
    return result.data;
  });
};

export const DeleteSubCategory = async (
  data: MainCategoryByIdRequest
): Promise<ApiResultModel<boolean>> => {
  return await Axios.delete<ApiResultModel<boolean>>(
    ApiBaseUrl + CategoryBaseURL + "/DeleteSubCategory/" + data.id
  ).then((result) => {
    return result.data;
  });
};
